module.exports = __webpack_public_path__ + "static/media/blog4.8f345f3a.png";